import { Modal, Button, Select, InputText } from '@insurancemenu/imenu-components-lib';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

interface Props {
  mode: 'ADD' | 'EDIT';
  show: boolean;
  onClose: () => void;
  onAction: () => void;
}

const eligibleMaintenanceOptions: OptionType[] = [
  { label: 'View only', value: 'View only' },
  { label: 'View and update', value: 'View and update' },
];

const onlineBillingOptions: OptionType[] = [
  { label: 'View only', value: 'View only' },
  { label: 'View & adjust', value: 'View & adjust' },
  { label: 'View, adjust & finalize', value: 'View, adjust & finalize' },
];

const AuthorizedUserModal: React.FC<Props> = observer(({ mode, show, onClose, onAction }) => {
  // Mobx store
  const {
    customAuthorizedUserStore: {
      form: {
        fields: { fullName, email, eligibility, billing },
        onFieldChange,
        isFormValid,
      },
    },
  } = useRootStore();

  // Component actions
  function callOnActionIfFormValid(): void {
    if (isFormValid()) {
      onAction();
    }
  }

  const classes = createStyles();
  return (
    <Modal show={show} onClose={onClose} width="71.2rem" closable={false}>
      <header className={classes.modalHeader}>
        <h2 className={classes.title}>{mode === 'ADD' ? 'Add' : 'Edit'} Authorized User</h2>
      </header>
      <div className={classes.modalBody}>
        <InputText
          label="Full Name"
          name="fullName"
          maxLength={50}
          value={fullName.value}
          onChange={onFieldChange}
          validationMessage={fullName.unpassedValidationMsg || ''}
          validationPassed={!fullName.unpassedValidationMsg}
          className={classes.regularField}
        />
        <InputText
          label="Email"
          name="email"
          maxLength={50}
          value={email.value}
          onChange={onFieldChange}
          validationMessage={email.unpassedValidationMsg || ''}
          validationPassed={!email.unpassedValidationMsg}
          className={classes.regularField}
        />
        <Select
          label="Eligibility Maintenance"
          name="eligibility"
          options={eligibleMaintenanceOptions}
          value={eligibility.value}
          onChange={onFieldChange}
          className={classes.regularField}
          validationPassed={!eligibility.unpassedValidationMsg}
          validationMessage={eligibility.unpassedValidationMsg || ''}
        />
        <Select
          label="Online Billing"
          name="billing"
          options={onlineBillingOptions}
          value={billing.value}
          onChange={onFieldChange}
          className={classes.regularField}
          validationPassed={!billing.unpassedValidationMsg}
          validationMessage={billing.unpassedValidationMsg || ''}
        />
      </div>
      <footer className={classes.modalFooter}>
        <Button type="outlined" onClick={onClose} size="large">
          Cancel
        </Button>
        <Button
          color="primary"
          htmlForm="add-edit-authorizedUser"
          size="large"
          onClick={callOnActionIfFormValid}
          className={classes.actionButton}
        >
          Save
        </Button>
      </footer>
    </Modal>
  );
});

export default AuthorizedUserModal;
